import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared/shared.module';

import { RegistrationsRoutingModule } from './registrations.routing';

import { InfoSectionComponent } from './components/info-section/info-section.component';
import { RegistrationsComponent } from './registrations.component';
import { RegistrationsListComponent } from './components/registrations-list/registrations-list.component';
import { SearchBikeComponent } from './components/search-bike/search-bike.component';
import { SearchUserComponent } from './components/search-user/search-user.component';
import { TransferBikeComponent } from './components/transfer-bike/transfer-bike.component';
import { ViewTransferDetailsComponent } from './components/view-transfer-details/view-transfer-details.component';
import { ViewBikeDetailsComponent } from './components/view-bike-details/view-bike-details.component';
import { ViewTransferHistoryComponent } from './components/view-transfer-history/view-transfer-history.component';
import { ViewUserDetailsComponent } from './components/view-user-details/view-user-details.component';

const components = [
	InfoSectionComponent,
	RegistrationsComponent,
	RegistrationsListComponent,
	SearchBikeComponent,
	SearchUserComponent,
	TransferBikeComponent,
	ViewBikeDetailsComponent,
	ViewTransferDetailsComponent,
	ViewTransferHistoryComponent,
	ViewUserDetailsComponent
];

@NgModule({
	declarations: [...components],
	imports: [
		RegistrationsRoutingModule, SharedModule
	]
})
export class RegistrationsModule { }
